import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
import { SectionEyebrow } from './SectionEyebrow';
import { CoverImage } from './CoverImage';
import { CTAButton } from './CTAButton';
const bullets = ['Estás cansada de dar más de lo que recibes', 'Quieres reconstruir tu autoestima y tu identidad', 'Deseas elevar tus estándares sin sentir culpa', 'Quieres sanar emocionalmente y dejar de repetir patrones', 'Anhelas volver a tu esencia femenina', 'Deseas fortalecer tu relación con Dios', 'Quieres sentirte más segura, clara y conectada contigo misma', 'Estás lista para convertirte en esa mujer'];
export function ParaQuienEs() {
  return <section className="py-24 md:py-32 px-6 bg-card" data-id="element-159">
      <div className="container max-w-[1100px] mx-auto" data-id="element-160">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-161">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="order-2 lg:order-1 flex justify-center" data-id="element-162">
            <div className="w-full max-w-[400px]" data-id="element-163">
              <CoverImage src="https://cdn.magicpatterns.com/uploads/5MGNjuQNrJY9EmSncq3zok/ChatGPT_Image_6_may_2026,_01_19_02_a.m._(2).png" alt="Mujer conectando consigo misma" hoverEffect={false} data-id="element-164" />
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="order-1 lg:order-2" data-id="element-165">
            <SectionEyebrow text="Para quién es esta experiencia" className="mb-6" data-id="element-166" />
            <h2 className="text-4xl md:text-5xl text-foreground mb-10" data-id="element-167">
              Este viaje es para ti,{' '}
              <span className="italic text-muted-foreground" data-id="element-168">si...</span>
            </h2>

            <ul className="space-y-5" data-id="element-169">
              {bullets.map((bullet, index) => <motion.li key={index} initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: index * 0.08
            }} className="flex items-start gap-4" data-id="element-170">
                  <Sparkles className="w-5 h-5 text-accent shrink-0 mt-1" strokeWidth={1.5} data-id="element-171" />
                  <span className="text-lg text-muted-foreground font-light" data-id="element-172">
                    {bullet}
                  </span>
                </motion.li>)}
            </ul>

            <div className="mt-10" data-id="element-173">
              <CTAButton text="Esto es para mí" data-id="element-174" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}